// Auto-generated — brochure slide copy for all 29 supported languages
// Edit `translate_brosch.py` and re-run to regenerate.

const COPY = {
  de: {
    over:   'DEIN EINSTIEG IN DIE STIG GROUP',
    title:  'Scanne den QR-Code und entdecke die Welt der STIG GROUP.',
    body:   'Erhalte Zugang zu unserer Unternehmensbroschüre und erfahre mehr über unsere Vision, unsere internationalen Geschäftsbereiche und die vier Säulen unseres Unternehmens.',
    checks: ['Unternehmensbroschüre', 'Die 4 Geschäftsbereiche', 'Unsere Vision & Werte', 'Internationale Standorte', 'Transparenz & Innovation'],
    outro:  'Deine Reise beginnt hier.',
  },
  en: {
    over:   'YOUR ENTRY INTO STIG GROUP',
    title:  'Scan the QR code and discover the world of STIG GROUP.',
    body:   'Gain access to our corporate brochure and learn more about our vision, our international business divisions and the four pillars of our company.',
    checks: ['Corporate Brochure', 'The 4 Business Divisions', 'Our Vision & Values', 'International Locations', 'Transparency & Innovation'],
    outro:  'Your journey begins here.',
  },
  fr: {
    over:   'VOTRE ENTRÉE DANS STIG GROUP',
    title:  'Scannez le code QR et découvrez l\'univers de STIG GROUP.',
    body:   'Accédez à notre brochure corporate et découvrez notre vision, nos domaines d\'activité internationaux et les quatre piliers de notre entreprise.',
    checks: ['Brochure corporate', 'Les 4 domaines d\'activité', 'Notre vision & valeurs', 'Implantations internationales', 'Transparence & Innovation'],
    outro:  'Votre parcours commence ici.',
  },
  es: {
    over:   'TU ENTRADA EN STIG GROUP',
    title:  'Escanea el código QR y descubre el mundo de STIG GROUP.',
    body:   'Accede a nuestro folleto corporativo y descubre más sobre nuestra visión, nuestras áreas de negocio internacionales y los cuatro pilares de nuestra empresa.',
    checks: ['Folleto corporativo', 'Las 4 áreas de negocio', 'Nuestra visión y valores', 'Sedes internacionales', 'Transparencia e innovación'],
    outro:  'Tu viaje comienza aquí.',
  },
  pt: {
    over:   'A TUA ENTRADA NA STIG GROUP',
    title:  'Digitaliza o código QR e descobre o mundo da STIG GROUP.',
    body:   'Obtém acesso à nossa brochura corporativa e fica a conhecer melhor a nossa visão, as nossas áreas de negócio internacionais e os quatro pilares da nossa empresa.',
    checks: ['Brochura corporativa', 'As 4 áreas de negócio', 'A nossa visão e valores', 'Localizações internacionais', 'Transparência e inovação'],
    outro:  'A tua jornada começa aqui.',
  },
  it: {
    over:   'IL TUO INGRESSO IN STIG GROUP',
    title:  'Scansiona il codice QR e scopri il mondo di STIG GROUP.',
    body:   'Accedi alla nostra brochure aziendale e scopri di più sulla nostra vision, le nostre aree di business internazionali e i quattro pilastri della nostra società.',
    checks: ['Brochure aziendale', 'Le 4 aree di business', 'La nostra vision e i nostri valori', 'Sedi internazionali', 'Trasparenza e innovazione'],
    outro:  'Il tuo viaggio inizia qui.',
  },
  nl: {
    over:   'JOUW TOEGANG TOT STIG GROUP',
    title:  'Scan de QR-code en ontdek de wereld van STIG GROUP.',
    body:   'Krijg toegang tot onze bedrijfsbrochure en ontdek meer over onze visie, onze internationale divisies en de vier pijlers van ons bedrijf.',
    checks: ['Bedrijfsbrochure', 'De 4 divisies', 'Onze visie & waarden', 'Internationale vestigingen', 'Transparantie & innovatie'],
    outro:  'Jouw reis begint hier.',
  },
  sv: {
    over:   'DIN INGÅNG TILL STIG GROUP',
    title:  'Skanna QR-koden och upptäck STIG GROUP:s värld.',
    body:   'Få tillgång till vår företagsbroschyr och lär dig mer om vår vision, våra internationella affärsområden och de fyra pelarna i vårt företag.',
    checks: ['Företagsbroschyr', 'De 4 affärsområdena', 'Vår vision & våra värderingar', 'Internationella kontor', 'Transparens & innovation'],
    outro:  'Din resa börjar här.',
  },
  pl: {
    over:   'TWÓJ START W STIG GROUP',
    title:  'Zeskanuj kod QR i odkryj świat STIG GROUP.',
    body:   'Uzyskaj dostęp do naszej broszury korporacyjnej i poznaj naszą wizję, międzynarodowe obszary działalności oraz cztery filary naszej firmy.',
    checks: ['Broszura korporacyjna', '4 obszary działalności', 'Nasza wizja i wartości', 'Lokalizacje międzynarodowe', 'Transparentność i innowacje'],
    outro:  'Twoja podróż zaczyna się tutaj.',
  },
  cs: {
    over:   'VÁŠ VSTUP DO STIG GROUP',
    title:  'Naskenujte QR kód a objevte svět STIG GROUP.',
    body:   'Získejte přístup k naší firemní brožuře a dozvíte se více o naší vizi, našich mezinárodních obchodních oblastech a čtyřech pilířích naší společnosti.',
    checks: ['Firemní brožura', '4 obchodní oblasti', 'Naše vize & hodnoty', 'Mezinárodní pobočky', 'Transparentnost & inovace'],
    outro:  'Vaše cesta začíná zde.',
  },
  sk: {
    over:   'VÁŠ VSTUP DO STIG GROUP',
    title:  'Naskenujte QR kód a objavte svet STIG GROUP.',
    body:   'Získajte prístup k našej firemnej brožúre a dozviete sa viac o našej vízii, našich medzinárodných obchodných oblastiach a štyroch pilieroch našej spoločnosti.',
    checks: ['Firemná brožúra', '4 obchodné oblasti', 'Naša vízia & hodnoty', 'Medzinárodné pobočky', 'Transparentnosť & inovácia'],
    outro:  'Vaša cesta sa začína tu.',
  },
  hu: {
    over:   'BELÉPÉSED A STIG GROUP-BA',
    title:  'Szkenneld be a QR-kódot és fedezd fel a STIG GROUP világát.',
    body:   'Szerezz hozzáférést vállalati prospektusunkhoz, és tudj meg többet vízióinkról, nemzetközi üzletágainkról és vállalatunk négy pilléréről.',
    checks: ['Vállalati prospektus', 'A 4 üzletág', 'Víziónk és értékeink', 'Nemzetközi irodák', 'Átláthatóság és innováció'],
    outro:  'Az utazásod itt kezdődik.',
  },
  ro: {
    over:   'INTRAREA TA ÎN STIG GROUP',
    title:  'Scanează codul QR și descoperă lumea STIG GROUP.',
    body:   'Obține acces la broșura noastră corporativă și află mai multe despre viziunea noastră, domeniile noastre internaționale de activitate și cele patru piloni ai companiei noastre.',
    checks: ['Broșura corporativă', 'Cele 4 domenii de activitate', 'Viziunea & valorile noastre', 'Locații internaționale', 'Transparență & inovație'],
    outro:  'Călătoria ta începe aici.',
  },
  sr: {
    over:   'TVOJ ULAZAK U STIG GROUP',
    title:  'Skeniraj QR kod i otkrij svet STIG GROUP.',
    body:   'Pristup našoj korporativnoj brošuri i saznaj više o našoj viziji, našim međunarodnim poslovnim oblastima i četiri stuba našeg preduzeća.',
    checks: ['Korporativna brošura', '4 poslovna područja', 'Naša vizija i vrednosti', 'Međunarodne lokacije', 'Transparentnost i inovacije'],
    outro:  'Tvoje putovanje počinje ovde.',
  },
  tr: {
    over:   'STIG GROUP\'A GİRİŞİN',
    title:  'QR kodu tarayın ve STIG GROUP dünyasını keşfedin.',
    body:   'Kurumsal broşürümüze erişim sağlayın ve vizyonumuz, uluslararası iş alanlarımız ve şirketimizin dört temel direği hakkında daha fazla bilgi edinin.',
    checks: ['Kurumsal Broşür', '4 İş Alanı', 'Vizyonumuz & Değerlerimiz', 'Uluslararası Lokasyonlar', 'Şeffaflık & İnovasyon'],
    outro:  'Yolculuğunuz burada başlıyor.',
  },
  bg: {
    over:   'ВАШИЯТ ВХОД В STIG GROUP',
    title:  'Сканирайте QR кода и открийте света на STIG GROUP.',
    body:   'Получете достъп до нашата корпоративна брошура и научете повече за нашата визия, нашите международни бизнес направления и четирите стълба на нашата компания.',
    checks: ['Корпоративна брошура', '4-те бизнес направления', 'Нашата визия и ценности', 'Международни локации', 'Прозрачност и иновации'],
    outro:  'Вашето пътуване започва тук.',
  },
  el: {
    over:   'Η ΕΙΣΟΔΟΣ ΣΟΥ ΣΤΗΝ STIG GROUP',
    title:  'Σκανάρισε τον κωδικό QR και ανακάλυψε τον κόσμο της STIG GROUP.',
    body:   'Απόκτησε πρόσβαση στο εταιρικό μας φυλλάδιο και μάθε περισσότερα για το όραμά μας, τους διεθνείς τομείς δραστηριότητάς μας και τους τέσσερις πυλώνες της εταιρείας μας.',
    checks: ['Εταιρικό Φυλλάδιο', 'Οι 4 Τομείς Δραστηριότητας', 'Το Όραμα & οι Αξίες μας', 'Διεθνείς Τοποθεσίες', 'Διαφάνεια & Καινοτομία'],
    outro:  'Το ταξίδι σου ξεκινά εδώ.',
  },
  sl: {
    over:   'VAŠ VSTOP V STIG GROUP',
    title:  'Skenirajte QR kodo in odkrijte svet STIG GROUP.',
    body:   'Pridobite dostop do naše podjetniške brošure in izvejte več o naši viziji, mednarodnih poslovnih področjih ter štirih stebrih našega podjetja.',
    checks: ['Podjetniška brošura', '4 poslovna področja', 'Naša vizija in vrednote', 'Mednarodne lokacije', 'Preglednost in inovacije'],
    outro:  'Vaše potovanje se začne tukaj.',
  },
  sq: {
    over:   'HYRJA JOTE NË STIG GROUP',
    title:  'Skano kodin QR dhe zbulo botën e STIG GROUP.',
    body:   'Merr qasje në broshurën tonë të kompanisë dhe mëso më shumë rreth vizionit tonë, fushave tona ndërkombëtare të biznesit dhe katër shtyllave të kompanisë sonë.',
    checks: ['Broshura e kompanisë', '4 fushat e biznesit', 'Vizioni & Vlerat tona', 'Vendndodhjet ndërkombëtare', 'Transparenca & Inovacioni'],
    outro:  'Udhëtimi yt fillon këtu.',
  },
  mk: {
    over:   'ТВОЈОТ ВЛЕЗ ВО STIG GROUP',
    title:  'Скенирај го QR кодот и открij го светот на STIG GROUP.',
    body:   'Добиј пристап до нашата корпоративна брошура и дознај повеќе за нашата визија, нашите меѓународни деловни области и четирите столба на нашата компанија.',
    checks: ['Корпоративна брошура', '4-те деловни области', 'Наша визија и вредности', 'Меѓународни локации', 'Транспарентност и иновација'],
    outro:  'Твоето патување започнува тука.',
  },
  uk: {
    over:   'ВАШ ВХІД ДО STIG GROUP',
    title:  'Скануйте QR-код і відкрийте для себе світ STIG GROUP.',
    body:   'Отримайте доступ до нашої корпоративної брошури та дізнайтеся більше про наше бачення, наші міжнародні бізнес-напрямки та чотири стовпи нашої компанії.',
    checks: ['Корпоративна брошура', '4 бізнес-напрямки', 'Наше бачення та цінності', 'Міжнародні локації', 'Прозорість і інновації'],
    outro:  'Ваша подорож починається тут.',
  },
  ru: {
    over:   'ТВОЙ ПУТЬ В STIG GROUP',
    title:  'Отсканируйте QR-код и откройте для себя мир STIG GROUP.',
    body:   'Получите доступ к корпоративной брошюре и узнайте больше о нашей миссии, международных направлениях бизнеса и четырех столпах нашей компании.',
    checks: ['Корпоративная брошюра', '4 направления бизнеса', 'Наша миссия и ценности', 'Международные офисы', 'Прозрачность и инновации'],
    outro:  'Ваш путь начинается здесь.',
  },
  mt: {
    over:   'ID-DĦUL TIEGĦEK FIS-STIG GROUP',
    title:  'Skannja l-Kodiċi QR u skopri d-dinja tas-STIG GROUP.',
    body:   'Ikseb aċċess għall-broxur korporattiv tagħna u tgħallem aktar dwar il-viżjoni tagħna, is-setturi kummerċjali internazzjonali tagħna u l-erba\' pilastri tal-kumpanija tagħna.',
    checks: ['Broxur Korporattiv', 'L-4 Setturi tan-Negozju', 'Il-Viżjoni u l-Valuri Tagħna', 'Postijiet Internazzjonali', 'Trasparenza u Innovazzjoni'],
    outro:  'Il-vjaġġ tiegħek jibda hawn.',
  },
  lb: {
    over:   'DÄIN ASTIEG AN D\'STIG GROUP',
    title:  'Scann de QR-Code an entdeck d\'Welt vun der STIG GROUP.',
    body:   'Kritt Zougang zu eiser Firmebroschür an erfaher méi iwwer eis Visioun, eis international Geschäftsbereicher an déi véier Säulen vun eisem Entreprise.',
    checks: ['Firmebroschür', 'Déi 4 Geschäftsbereicher', 'Eis Visioun & Wäerter', 'International Standuerter', 'Transparenz & Innovatioun'],
    outro:  'Deng Rees fänkt hei un.',
  },
  ar: {
    over:   'بوابتك إلى STIG GROUP',
    title:  'امسح رمز الاستجابة السريعة واكتشف عالم STIG GROUP.',
    body:   'احصل على إمكانية الوصول إلى كتيب شركتنا وتعرف على المزيد حول رؤيتنا ومجالات أعمالنا الدولية والركائز الأربع لشركتنا.',
    checks: ['كتيب الشركة', 'مجالات الأعمال الأربعة', 'رؤيتنا وقيمنا', 'مواقعنا الدولية', 'الشفافية والابتكار'],
    outro:  'رحلتك تبدأ هنا.',
  },
  zh: {
    over:   '开启您的STIG GROUP之旅',
    title:  '扫描二维码,探索STIG GROUP的世界。',
    body:   '获取我们的企业宣传册,深入了解我们的愿景、国际业务板块以及企业的四大支柱。',
    checks: ['企业宣传册', '四大业务板块', '我们的愿景与价值观', '国际办事处', '透明与创新'],
    outro:  '您的旅程从这里开始。',
  },
  ja: {
    over:   'STIG GROUPへの入口',
    title:  'QRコードをスキャンして、STIG GROUPの世界を発見してください。',
    body:   '当社の企業ブローシャーにアクセスし、私たちのビジョン、国際的なビジネス部門、そして当社の4つの柱について詳しく学んでください。',
    checks: ['企業ブローシャー', '4つのビジネス部門', 'ビジョンと価値観', '国際的な拠点', '透明性とイノベーション'],
    outro:  'あなたの旅はここから始まります。',
  },
  ko: {
    over:   'STIG GROUP으로의 여정을 시작하세요',
    title:  'QR 코드를 스캔하고 STIG GROUP의 세계를 발견하세요.',
    body:   '기업 브로슈어를 통해 저희의 비전, 글로벌 사업 부문, 그리고 기업을 지탱하는 네 가지 핵심 가치에 대해 알아보세요.',
    checks: ['기업 브로슈어', '4대 사업 부문', '비전 & 가치', '글로벌 거점', '투명성 & 혁신'],
    outro:  '당신의 여정이 여기서 시작됩니다.',
  },
  hi: {
    over:   'STIG GROUP में आपका प्रवेश',
    title:  'QR कोड स्कैन करें और STIG GROUP की दुनिया की खोज करें।',
    body:   'हमारे कॉर्पोरेट ब्रोशर तक पहुँच प्राप्त करें और हमारी दृष्टि, हमारे अंतर्राष्ट्रीय व्यवसाय क्षेत्रों और हमारी कंपनी के चार स्तंभों के बारे में अधिक जानें।',
    checks: ['कॉर्पोरेट ब्रोशर', '4 व्यवसाय क्षेत्र', 'हमारी दृष्टि और मूल्य', 'अंतर्राष्ट्रीय स्थान', 'पारदर्शिता और नवाचार'],
    outro:  'आपकी यात्रा यहाँ से शुरू होती है।',
  },
};

export default COPY;
